<script setup lang="ts">
import type { BackButtonProps } from '@/types'

type Props = BackButtonProps
const props = defineProps<Props>()
</script>
<template>
  <router-link :to="props.to" custom v-slot="{ href, navigate }">
    <a
      :href="href"
      @click="navigate"
      class="text-blue-500 font-weight-bold text-md d-flex align-items-center"
    >
      <i class="return-icon mr-2"></i>
      <span>
        {{ props?.text ? $t(`${props?.text}`) : $t('form.label.back') }}
      </span>
    </a>
  </router-link>
</template>
